import React from 'react';
import { connect } from 'react-redux';

import Loader from '../shared/components/Loader';

import { check } from './authActions';

class AuthLoader extends React.Component {
  componentDidMount() {
    this.props.check();
  }

  render() {
    return (
      <Loader fullScreen />
    );
  }
}

export default connect(null, { check })(AuthLoader);
